
import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function VoiceSearchFAQSection() {
  const [activeIndex, setActiveIndex] = useState<number | null>(0);

  const voiceFAQs = [
    {
      question: '搬家前要準備什麼？',
      answer: '搬家前建議提前 2-4 週開始準備：整理物品並斷捨離、準備打包材料（紙箱、氣泡紙、膠帶）、通知水電瓦斯公司遷移、向管委會申請電梯使用、規劃新家動線。我們提供免費到府估價，幫您規劃最佳搬家方案！',
      icon: 'ri-checkbox-circle-line',
      color: 'teal',
      link: '/knowledge/article/moving-preparation-qa-2026',
      linkText: '查看完整準備清單'
    },
    {
      question: '搬家公司怎麼選？',
      answer: '選擇搬家公司要注意：確認是否有合法營業登記、查看網路評價與口碑、比較報價是否透明（避免隱藏費用）、確認是否有保險保障、詢問是否提供打包服務。建鈞搬家 10 年經驗、透明收費、全程保險，是新北台北搬家首選！',
      icon: 'ri-building-2-line',
      color: 'emerald',
      link: '/knowledge/article/choosing-moving-company-qa-2026',
      linkText: '搬家公司選擇指南'
    },
    {
      question: '搬家要多少錢？',
      answer: '搬家費用依據物品數量、距離、樓層而定：套房搬遷約 3,000-5,000 元、小家庭搬遷約 5,000-8,000 元、大家庭搬遷約 8,000-15,000 元。建鈞搬家提供透明報價，到府估價完全免費，絕無隱藏費用！',
      icon: 'ri-money-dollar-circle-line',
      color: 'amber',
      link: '/knowledge/article/moving-cost-qa-2026',
      linkText: '搬家費用完整解析'
    },
    {
      question: '搬家當天要注意什麼？',
      answer: '搬家當天注意事項：提前清空冰箱並除霜、確認停車位置、貴重物品隨身攜帶、現場確認物品清單、檢查新舊家水電是否正常、拍照記錄物品狀態。我們的專業團隊會全程協助，讓您搬家無憂！',
      icon: 'ri-calendar-check-line',
      color: 'orange',
      link: '/knowledge/article/moving-day-qa-2026',
      linkText: '搬家當天完整流程'
    },
    {
      question: '搬家怎麼省比較快？',
      answer: '省錢搬家技巧：選擇平日或月中搬家（避開旺季）、提前整理減少物品數量、自行打包節省人工費、善用免費紙箱資源、多家比價選擇 CP 值最高的方案。加入我們的 LINE 可獲得專屬優惠報價！',
      icon: 'ri-wallet-line',
      color: 'green',
      link: '/knowledge/article/save-moving-cost-qa-2026',
      linkText: '15 個省錢技巧'
    }
  ];

  return (
    <section className="py-16 md:py-24 bg-gradient-to-br from-gray-50 via-white to-teal-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* 標題區塊 */}
        <div className="text-center mb-12 md:mb-16">
          <div className="inline-flex items-center gap-2 bg-gradient-to-r from-teal-500 to-emerald-500 text-white px-5 py-2.5 rounded-full text-sm font-semibold mb-5 shadow-lg">
            <i className="ri-mic-line text-lg"></i>
            <span>AI 語音搜尋優化</span>
          </div>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4 md:mb-6">
            大家都在問的<span className="text-teal-600">搬家問題</span>
          </h2>
          <p className="text-lg md:text-xl text-gray-600 max-w-3xl mx-auto">
            直接用口語問，我們給你最專業的解答！<br className="hidden sm:block" />
            <span className="text-teal-600 font-semibold">10 年搬家經驗</span>，解決您所有搬家疑問
          </p>
        </div>

        {/* FAQ 手風琴區塊 */}
        <div className="max-w-4xl mx-auto">
          <div className="space-y-4">
            {voiceFAQs.map((faq, index) => (
              <div 
                key={index}
                className={`bg-white rounded-2xl shadow-md overflow-hidden transition-all duration-300 border-2 ${
                  activeIndex === index ? 'border-teal-400 shadow-xl shadow-teal-100' : 'border-transparent hover:border-gray-200'
                }`}
              >
                {/* 問題標題 */}
                <button
                  onClick={() => setActiveIndex(activeIndex === index ? null : index)}
                  className="w-full flex items-center gap-4 p-5 md:p-6 text-left cursor-pointer hover:bg-gray-50 transition-colors"
                >
                  <div className={`bg-${faq.color}-100 w-14 h-14 rounded-xl flex items-center justify-center flex-shrink-0 transition-transform ${
                    activeIndex === index ? 'scale-110' : ''
                  }`}>
                    <i className={`${faq.icon} text-${faq.color}-600 text-2xl`}></i>
                  </div>
                  <div className="flex-1">
                    <div className="flex items-center gap-2 mb-1">
                      <span className="bg-teal-100 text-teal-700 px-2 py-0.5 rounded text-xs font-semibold">
                        熱門問題
                      </span>
                    </div>
                    <h3 className="text-xl md:text-2xl font-bold text-gray-900">
                      「{faq.question}」
                    </h3>
                  </div>
                  <div className={`w-10 h-10 rounded-full flex items-center justify-center transition-all ${
                    activeIndex === index ? 'bg-teal-600 rotate-180' : 'bg-gray-100'
                  }`}>
                    <i className={`ri-arrow-down-s-line text-2xl ${
                      activeIndex === index ? 'text-white' : 'text-gray-500'
                    }`}></i>
                  </div>
                </button>

                {/* 答案內容 */}
                <div className={`overflow-hidden transition-all duration-300 ${
                  activeIndex === index ? 'max-h-96' : 'max-h-0'
                }`}>
                  <div className="px-5 md:px-6 pb-6 pt-2">
                    <div className="bg-gradient-to-br from-gray-50 to-teal-50 rounded-xl p-5 md:p-6">
                      <p className="text-gray-700 text-base md:text-lg leading-relaxed mb-4">
                        {faq.answer}
                      </p>
                      <div className="flex flex-col sm:flex-row gap-3">
                        <Link 
                          to={faq.link}
                          className="inline-flex items-center justify-center gap-2 bg-teal-600 text-white px-5 py-2.5 rounded-lg font-semibold hover:bg-teal-700 transition-colors cursor-pointer whitespace-nowrap text-sm"
                        >
                          <i className="ri-article-line"></i>
                          {faq.linkText}
                        </Link>
                        <a 
                          href="https://line.me/ti/p/@285yavdh"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="inline-flex items-center justify-center gap-2 bg-green-600 text-white px-5 py-2.5 rounded-lg font-semibold hover:bg-green-700 transition-colors cursor-pointer whitespace-nowrap text-sm"
                        >
                          <img 
                            src="https://static.readdy.ai/image/9ef47c451bf9aafd7a63eea67af7d95d/c33a3c3f2fa31df7dfad05bfabc09369.webp" 
                            alt="LINE" 
                            className="w-4 h-4"
                            loading="lazy"
                          />
                          LINE 免費諮詢
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* 更多問題提示 */}
        <div className="mt-12 md:mt-16">
          <div className="bg-gradient-to-r from-teal-600 via-emerald-600 to-teal-600 rounded-3xl p-8 md:p-12 text-center shadow-2xl relative overflow-hidden">
            {/* 背景裝飾 */}
            <div className="absolute top-0 left-0 w-full h-full opacity-10">
              <div className="absolute top-10 left-10 w-32 h-32 bg-white rounded-full"></div>
              <div className="absolute bottom-10 right-10 w-48 h-48 bg-white rounded-full"></div>
            </div>
            
            <div className="relative z-10">
              <div className="flex items-center justify-center gap-3 mb-4">
                <i className="ri-question-answer-line text-4xl text-white"></i>
              </div>
              <h3 className="text-2xl md:text-3xl font-bold text-white mb-4">
                還有其他搬家問題想問？
              </h3>
              <p className="text-white/90 text-base md:text-lg mb-8 max-w-2xl mx-auto">
                不管是搬家費用、打包技巧、還是特殊物品搬運，<br className="hidden sm:block" />
                我們的專業團隊都能為您解答！
              </p>
              
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <a 
                  href="https://line.me/ti/p/@285yavdh"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center gap-3 bg-white text-teal-600 px-8 py-4 rounded-full text-lg font-bold hover:bg-gray-50 transition-all cursor-pointer shadow-xl hover:shadow-2xl hover:scale-105 whitespace-nowrap"
                >
                  <img 
                    src="https://static.readdy.ai/image/9ef47c451bf9aafd7a63eea67af7d95d/c33a3c3f2fa31df7dfad05bfabc09369.webp" 
                    alt="LINE" 
                    className="w-6 h-6"
                    loading="lazy"
                  />
                  <span>LINE 即時問答</span>
                  <i className="ri-arrow-right-line text-xl"></i>
                </a>
                <Link 
                  to="/faq"
                  className="inline-flex items-center justify-center gap-2 bg-white/20 backdrop-blur-sm text-white px-8 py-4 rounded-full text-lg font-bold hover:bg-white/30 transition-all cursor-pointer whitespace-nowrap border-2 border-white/30"
                >
                  <i className="ri-file-list-3-line text-xl"></i>
                  <span>查看完整 FAQ</span>
                </Link>
              </div>
            </div>
          </div>
        </div>

        {/* SEO 優化：相關搜尋關鍵字 */}
        <div className="mt-12 text-center">
          <p className="text-gray-500 text-sm mb-4">相關搜尋：</p>
          <div className="flex flex-wrap justify-center gap-2">
            {[
              '新北搬家推薦',
              '台北搬家公司',
              '搬家費用計算',
              '搬家打包技巧',
              '搬家注意事項',
              '搬家省錢方法',
              '廢棄物清運'
            ].map((keyword, index) => (
              <Link 
                key={index}
                to="/knowledge"
                className="bg-gray-100 hover:bg-teal-100 text-gray-600 hover:text-teal-700 px-4 py-2 rounded-full text-sm transition-colors cursor-pointer"
              >
                {keyword}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
